import { useNavigate, useParams } from "react-router-dom";
import Header from '../components/Header'
import { t } from "../app/Translate";
import { motion } from "framer-motion";
import svg1 from '../svg/F-Bene4-CP.svg';
import svg2 from '../svg/I-Bene3-CP.svg';
import svg3 from '../svg/INF-Bene3-CP.svg';
import svg4 from '../svg/F-Bene3-CP.svg';

import './Index.css'
import AnimatedCounter from "../components/AnimatedCounter";
import FAQItem from "../components/FaqItem";
import { useEffect, useState } from "react";
import FormContact from "../components/FormContact";
import Footer from "../components/Footer";

const Main = () => {     
    const {isocode}: any = useParams();
    const [openIndex, setOpenIndex] = useState<number | null>(null);
    const navigate = useNavigate();
    const items = [
        {
            img: "../../images/Vent-1-768x384.jpg",
            title: t("main.titlewhy1"),
            text: t("main.textwhy1"),
        },
        {
            img: "../../images/Vent-2-768x384.jpg",
            title: t("main.titlewhy2"),
            text: t("main.textwhy2"),
        },
        {
            img: "../../images/Vent-3-768x384.jpg",
            title: t("main.titlewhy3"),
            text: t("main.textwhy3"),
        },
    ];

    function NavigateTo(){
        let urlRegister = "/" + isocode + "/plans/" 
        navigate(urlRegister);
    }

    return (
        <>
            <Header isocode={isocode} active="home"/>
            <main className="main-content">
                <section className="header-home">
                    <div className="row" style={{paddingTop:"45px"}}>
                        <div className="col-md-6 bannertext1" style={{paddingTop:"50px"}}>
                            {t("main.headertext1")}
                            <div className="bannertext2">
                                {t("main.headertext2")}
                            </div>
                        </div>
                        <div className="col-md-6 onlydesktop">
                            <img src="../../images/Main-Banner-Home-768x631.png" className="header-image"/>
                        </div>                        
                    </div>                    
                </section>

                <section className="whymakos-section padmakos">
                    <h2 className="whymakos-title">{t("main.whycard")}</h2>
                    <div className="row" style={{ marginTop: "30px" }}>
                        {items.map((item, index) => (
                        <div className="col-md-4" key={index}>
                            {/* Imagen animada */}
                            <motion.img
                            src={item.img}
                            className="why-img"
                            initial={{ opacity: 0, y: -50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: index * 0.3 }}
                            />

                            {/* Card animada */}
                            <motion.div
                            className="why-card"
                            initial={{ opacity: 0, y: -50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: index * 0.3 + 0.2 }}
                            >
                            <div className="why-card-body">
                                <div className="why-card-bodytitle">{item.title}</div>
                                <div className="why-card-bodycontent">{item.text}</div>
                            </div>                            
                            </motion.div>
                        </div>
                        ))}
                    </div>
                </section>

                <section className="main-section1 padmakos">
                    <div className="row">
                        <div className="col-md-1"></div>
                        <div className="col-md-5">
                            <div className="IconSection">
                                <img src={svg1} alt="icon"/>
                            </div>
                            <div className="title-section1">
                                {t("main.titlesection1")}
                            </div>
                            <div className="body-section1">
                                {t("main.bodysection1")}
                            </div>
                        </div>
                        <div className="col-md-5">
                            <motion.img
                                src="../../images/Tesoreria-Gastos-1024x530.png"
                                className="img-section1"
                                initial={{ opacity: 0, x: 100 }}   
                                whileInView={{ opacity: 1, x: 0 }} 
                                viewport={{ once: true }}
                                transition={{ duration: 0.8 }}
                            />                            
                        </div>
                        <div className="col-md-1"></div>       
                    </div>
                </section>

                <section className="main-section2 padmakos">
                    <div className="row">
                        <div className="col-md-1"></div>       
                        <div className="col-md-5">
                            <motion.img
                                src="../../images/Inventario-Categoria-4.png"
                                className="img-section1"
                                initial={{ scale: 0, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 0.8, ease: "easeOut" }} 
                                whileInView={{ scale: 1, opacity: 1 }} 
                                viewport={{ once: true, amount: 0.5 }}                                 
                            />                            
                        </div>
                        <div className="col-md-5" style={{paddingTop:"70px"}}>
                            <div className="IconSection">
                                <img src={svg2} alt="icon"/>
                            </div>
                            <div className="title-section1">
                                {t("main.titlesection2")}
                            </div>
                            <div className="body-section1">
                                {t("main.bodysection2")}
                            </div>
                        </div>                  
                        <div className="col-md-1"></div>                          
                    </div>
                </section>

                <section className="main-section1 padmakos">
                    <div className="row">
                        <div className="col-md-1"></div>
                        <div className="col-md-5">
                            <div className="IconSection">
                                <img src={svg3} alt="icon"/>
                            </div>
                            <div className="title-section1">
                                {t("main.titlesection3")}
                            </div>
                            <div className="body-section1">
                                {t("main.bodysection3")}
                            </div>
                        </div>
                        <div className="col-md-5">
                            <motion.img
                                src="../../images/Informe-excel-2-768x398.png"
                                className="img-section1"
                                initial={{ opacity: 0, x: 100 }}   
                                whileInView={{ opacity: 1, x: 0 }} 
                                viewport={{ once: true }}
                                transition={{ duration: 0.8 }}
                            />                            
                        </div>
                        <div className="col-md-1"></div>       
                    </div>
                </section>

                <section className="main-section2 padmakos">
                    <div className="row">
                        <div className="col-md-1"></div>       
                        <div className="col-md-5">
                            <motion.img
                                src="../../images/Facturar-2.png"
                                className="img-section1"
                                initial={{ scale: 0, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 0.8, ease: "easeOut" }} 
                                whileInView={{ scale: 1, opacity: 1 }} 
                                viewport={{ once: true, amount: 0.5 }}                                 
                            />                            
                        </div>
                        <div className="col-md-5" style={{paddingTop:"70px"}}>
                            <div className="IconSection">
                                <img src={svg4} alt="icon"/>
                            </div>
                            <div className="title-section1">
                                {t("main.titlesection4")}
                            </div>
                            <div className="body-section1">
                                {t("main.bodysection4")}
                            </div>
                        </div>    
                        <div className="col-md-1"></div>                                        
                    </div>
                </section>

                <section className="main-customers padmakos" style={{fontSize:"70px",fontWeight:"bolder"}}>
                    <h2 className="whymakos-title">{t("main.customertitle")}</h2>
                    <div className="row">
                        <div className="col-md-2"></div>
                        <div className="col-md-8">
                            <div className="row">
                                <div className="col-md-4">
                                    <span className="divider-separator"></span> 
                                    <AnimatedCounter value={16} />
                                    <div className="main-customerstags">{t("main.customersyear")}</div> 						
                                </div>
                                <div className="col-md-4">
                                    <span className="divider-separator"></span> 
                                    <AnimatedCounter value={5000} />
                                    <div className="main-customerstags">{t("main.customersusers")}</div> 
                                </div>
                                <div className="col-md-4">
                                    <span className="divider-separator"></span> 
                                    <AnimatedCounter value={400} />
                                    <div className="main-customerstags">{t("main.customersbussiness")}</div> 
                                </div>
                            </div>
                        </div>
                        <div className="col-md-2"></div>                        
                    </div>
                </section>

                <section className="main-section2 padmakos">
                    <div className="bordercolors" style={{marginTop:"40px",marginBottom:"80px"}}>
                        <div className="bordercolorsbody">
                            <div className="row">
                                <div className="col-md-1"></div>
                                <div className="col-md-6">
                                    <div className="cta-question" style={{color:"#282C40"}}>{t("main.ctaquestion")}</div>
                                    <div className="cta-message" style={{color:"#282C40"}}>{t("main.ctamessage")}</div>
                                </div>
                                <div className="col-md-4" style={{flexDirection:"column",display:"flex",paddingBottom:"70px", width:"100%"}}>                                    
                                    <center>                                                                             
                                        <button onClick={NavigateTo} className="animated-button" style={{width:"100%",marginTop:"10px"}}>{t("main.ctabutton")}</button>                                                                                                                                                         
                                    </center>
                                </div>
                                <div className="col-md-1"></div>
                            </div>                                                                     
                        </div>
                    </div>
                </section>

                <section className="main-section2 padmakos"  style={{textAlign:"center", marginTop:"-70px" ,paddingTop:"0px"}}>                    
                    <div className="main-faqs padmakos">                        
                        <div className="row">
                            <div className="col-md-2"></div>
                            <div className="col-md-8">
                                <h2 className="whymakos-title" style={{color:"#282C40",textAlign:"center", padding:"20px", paddingBottom:"30px"}}>{t("faqs.faqtitle")}</h2>                    
                                <FAQItem key={1} question={t("faqs.question1")} answer={t("faqs.answer1")} action={t("faqs.action1")} isOpen={openIndex === 1} onClick={() => setOpenIndex(openIndex === 1 ? null : 1)} />
                                <FAQItem key={2} question={t("faqs.question2")} answer={t("faqs.answer2")} action={t("faqs.action2")} isOpen={openIndex === 2} onClick={() => setOpenIndex(openIndex === 2 ? null : 2)}/>
                                <FAQItem key={3} question={t("faqs.question3")} answer={t("faqs.answer3")} action={t("faqs.action3")} isOpen={openIndex === 3} onClick={() => setOpenIndex(openIndex === 2 ? null : 3)}/>
                                <FAQItem key={4} question={t("faqs.question4")} answer={t("faqs.answer4")} action={t("faqs.action4")} isOpen={openIndex === 4} onClick={() => setOpenIndex(openIndex === 2 ? null : 4)}/>
                                <FAQItem key={5} question={t("faqs.question5")} answer={t("faqs.answer5")} action={t("faqs.action5")} isOpen={openIndex === 5} onClick={() => setOpenIndex(openIndex === 2 ? null : 5)}/>
                                <FAQItem key={6} question={t("faqs.question6")} answer={t("faqs.answer6")} action={t("faqs.action6")} isOpen={openIndex === 6} onClick={() => setOpenIndex(openIndex === 2 ? null : 6)}/>
                            </div>
                            <div className="col-md-2"></div>
                        </div>                                                                    
                    </div>                    
                </section>

                <FormContact isocode={isocode} />                    
                <Footer isocode={isocode} />                
            </main>
        </>
    )
}

export default Main;